import { ExpandMore } from "@mui/icons-material";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useState } from "react";

const Container = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
});

const CustomAccordion = styled(Accordion)(({ expanded }) => ({
  borderRadius: "12px",
  marginBottom: "6px",
  "&.Mui-expanded": {
    backgroundColor: "#10366e",
    borderRadius: "12px 12px 0px 0px",
  },
}));

const CustomSummary = styled(AccordionSummary)(({ theme }) => ({
  backgroundColor: "#10366e",
  color: "white",
  borderRadius: "12px",
  "&.Mui-expanded": {},
  "& .MuiAccordionSummary-content": {
    margin: 0,
    alignItems: "center",
  },
  "& .MuiAccordionSummary-expandIconWrapper": {
    color: "white",
  },
}));

const CustomDetails = styled(AccordionDetails)(({ theme }) => ({
  backgroundColor: "#ffffff",
  border: "solid 1px darkgray",
  overflowY: "auto",
}));

const FlexibleAccordion = styled(Accordion, {
  shouldForwardProp: (prop) =>
    prop !== "isExpanded" && prop !== "hasLongContent",
})(({ isExpanded, hasLongContent }) => ({
  display: "flex",
  flexDirection: "column",
  flex: isExpanded && hasLongContent ? 1 : "unset",
  "&.Mui-expanded": {
    backgroundColor: "#10366e",
    borderRadius: "12px 12px 0px 0px",
  },
}));

export default function ExpandableView({ components, defaultExpandedIndex }) {
  const [expandedIndexes, setExpandedIndexes] = useState(
    defaultExpandedIndex >= 0 ? [defaultExpandedIndex] : []
  );

  const handleChange = (panelIndex) => (event, isExpanded) => {
    if (isExpanded) {
      setExpandedIndexes([...expandedIndexes, panelIndex]);
      return;
    }

    const index = expandedIndexes.findIndex((x) => x === panelIndex);
    if (index >= 0) {
      expandedIndexes.splice(index, 1);
      setExpandedIndexes([...expandedIndexes]);
    }
  };

  return (
    <Container>
      {components &&
        components.length > 0 &&
        components.map((component, index) =>
          component.LongContent ? (
            <FlexibleAccordion
              key={index}
              hasLongContent
              expanded={expandedIndexes.includes(index)}
              onChange={handleChange(index)}
            >
              <CustomSummary
                expandIcon={<ExpandMore />}
                aria-expanded={component.Expanded}
              >
                <Typography component="span">{component.Name}</Typography>
              </CustomSummary>
              <CustomDetails>{component.Component}</CustomDetails>
            </FlexibleAccordion>
          ) : (
            <CustomAccordion
              key={index}
              expanded={expandedIndexes.includes(index)}
              onChange={handleChange(index)}
            >
              <CustomSummary
                expandIcon={<ExpandMore />}
                aria-expanded={component.Expanded}
              >
                <Typography component="span">{component.Name}</Typography>
              </CustomSummary>
              <CustomDetails>{component.Component}</CustomDetails>
            </CustomAccordion>
          )
        )}
    </Container>
  );
}
